//
// Latitude, and longitude validation regex source: https://stackoverflow.com/a/31408260/9121074
//
export default [
    {
        name: "organizationId",
        label: "Client",
        type: "list",
        url: "/organizations",
        filterValue: "name",
        entityName: "organizationName",
    },
    {
        name: "areaId",
        label: "Area",
        type: "list",
        url: "/areas",
        filterValue: "name",
        errorMessage: "Area is required",
        validation: {
            required: true,
        },
        entityName: "areaName",
        itemLabels: ["name", "cityName"],
    },
    {
        name: "locationCategoryId",
        label: "Location Category",
        type: "list",
        url: "/location-categories",
        errorMessage: "Location category is required",
        filterValue: "nameAr",
        validation: {
            required: true,
        },
        entityName: "locationCategoryName",
    },
    {
        name: "outletTypeId",
        label: "Outlet Type",
        type: "list",
        url: "/outlet-types",
        filterValue: "nameAr",
        errorMessage: "Outlet type is required",
        validation: {
            required: true,
        },
        entityName: "outletTypeName",
    },
    {
        name: "locationType",
        label: "Location Type",
        type: "select",
        errorMessage: "Location type is required",
        data: [
            { value: "pickup", text: "Pickup" },
            { value: "dropoff", text: "Dropoff" },
        ],
        validation: {
            required: true,
        },
    },
    {
        name: "address",
        label: "Address",
        type: "string",
        helpText: "Location's address",
        errorMessage: "Address type is required",
        validation: {
            required: true,
        },
    },
    {
        name: "name",
        label: "Name",
        type: "string",
        helpText: "Location's name",
        errorMessage: "Name type is required",
        validation: {
            required: true,
        },
    },
    {
        name: "latitude",
        label: "Latitude",
        type: "string",
        helpText: "Location's latitude",
        errorMessage: "Latitude is required",
        validation: {
            required: true,
            pattern: /^(\+|-)?([0-9]{1,2}\.[0-9]{6,})?$/,
        },
    },
    {
        name: "longitude",
        label: "Longitude",
        type: "string",
        helpText: "Location's longitude",
        errorMessage: "Longitude is required",
        validation: {
            required: true,
            pattern: /^(\+|-)?([0-9]{1,3}\.[0-9]{6,})?$/,
        },
    },
];
